import { render, staticRenderFns } from "./BreakDown.vue?vue&type=template&id=77deae49&scoped=true&"
import script from "./BreakDown.vue?vue&type=script&lang=js&"
export * from "./BreakDown.vue?vue&type=script&lang=js&"
import style0 from "./BreakDown.vue?vue&type=style&index=0&id=77deae49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77deae49",
  null
  
)

export default component.exports